import parse, { DOMNode, domToReact, Element, HTMLReactParserOptions } from 'html-react-parser';
import { createElement, ReactNode } from 'react';

/** Only these tags reach the page, every attribute except a safe href is dropped. */
const ALLOWED_TAGS = new Set([
  'h2',
  'h3',
  'p',
  'br',
  'ul',
  'ol',
  'li',
  'a',
  'strong',
  'b',
  'em',
  'i',
  'u',
  'blockquote',
  'table',
  'thead',
  'tbody',
  'tr',
  'th',
  'td',
]);

const DROPPED_TAGS = new Set([
  'script',
  'style',
  'iframe',
  'object',
  'embed',
  'noscript',
  'template',
  'form',
  'input',
  'button',
  'svg',
  'img',
]);

const HEADING_FALLBACKS: Record<string, string> = { h1: 'h2', h4: 'h3', h5: 'h3', h6: 'h3' };

const SAFE_HREF_REGEX = /^(https?:\/\/|\/(?!\/)|#|mailto:|tel:)/i;

const VOID_TAGS = new Set(['br']);

const options: HTMLReactParserOptions = {
  replace(domNode) {
    if (!(domNode instanceof Element)) return undefined;
    if (DROPPED_TAGS.has(domNode.name)) return <></>;

    const tagName = HEADING_FALLBACKS[domNode.name] ?? domNode.name;
    const children = domToReact(domNode.children as DOMNode[], options);

    if (!ALLOWED_TAGS.has(tagName)) return <>{children}</>;
    if (VOID_TAGS.has(tagName)) return createElement(tagName);

    if (tagName === 'a') {
      const href = domNode.attribs.href?.trim();
      return href && SAFE_HREF_REGEX.test(href) ? <a href={href}>{children}</a> : <>{children}</>;
    }

    return createElement(tagName, null, children);
  },
};

export const renderJobTitlePageHtml = (html: string): ReactNode => parse(html, options);
